/** The root's shell for a template's example page: its own document, no site or Drate chrome. */
export type TemplatePreviewShell = { templatePreview: true };

export function isTemplatePreviewShell(shell: unknown): shell is TemplatePreviewShell {
  return !!shell && typeof shell === "object" && "templatePreview" in shell;
}
